import { Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { ProjectDto } from "@/core/features/projects/project.dto";
import { CurrencyDto } from "@/core/features/currencies/currency.dto";
import { OptionType } from "@/types/OptionType";

export class ProjectHasCurrencyDto extends BaseEntityDto {
  @Type(() => ProjectDto)
  project: ProjectDto;
  projectId: string;

  @Type(() => CurrencyDto)
  currency: CurrencyDto;
  currencyId: string;

  mapEntityToOptionType(labels: string[]): OptionType {
    return {
      label: labels.join(" "),
      value: this.currencyId,
    };
  }
}
